import type { BlockUserRef } from "../api/types";
import { initials } from "../lib/format";

// UserRefChip renders a resolved user ref as a small avatar + name chip, with
// an optional role prefix ("Owner", "Assignee", "Sponsor"). Shared by block
// cards, the detail page, dashboard pillar headers, and the pillars table.
export function UserRefChip({ user, title }: { user: BlockUserRef; title?: string }) {
  const display = user.name.trim() === "" ? user.email : user.name;
  return (
    <span className="chip user-ref-chip" title={user.email}>
      {user.avatar_url !== "" ? (
        <img className="user-ref-chip__avatar" src={user.avatar_url} alt="" />
      ) : (
        <span className="user-ref-chip__avatar user-ref-chip__avatar--initials">
          {initials(user.name, user.email)}
        </span>
      )}
      {title !== undefined && <span className="user-ref-chip__role">{title}</span>}
      <span className="user-ref-chip__name">{display}</span>
    </span>
  );
}
